import React, { useMemo } from 'react'
import { Card, CardTitle, CardBody, CardFooter, Table } from "reactstrap";
import { DownloadDocument } from 'helpers/files';
import { authenticationService } from 'services/authentication.service';
import { HistorialSolicitudesPermisos, HistorialSolicitudesPermisosbyAnio } from './TypesSolicitudesPermisos';
import { formatoFecha, IPropsDashboardIndividual } from './../../../Admin/Inicio-Admin/Dashboard_Individual_Admin';

import PdfSVG from "assets/icons/Permisos/PDF(azul).svg"

type PropsCardHistorialSolicitudesPermisos = {
    informacion: HistorialSolicitudesPermisosbyAnio;
    color: string;
    verDetalleHistorico: (anio: number) => Promise<void>,
}

export default function CardHistorialSolicitudesPermisos(props: PropsCardHistorialSolicitudesPermisos) {
    const meses = {
        enero: 1,
        febrero: 2,
        marzo: 3,
        abril: 4,
        mayo: 5,
        junio: 6,
        julio: 7,
        agosto: 8,
        septiembre: 9,
        octubre: 10,
        noviembre: 11,
        diciembre: 12
    };
    const { key, value } = props.informacion;
    const mensajeCard2018 = "A partir del 2019 para el personal de LOSEP y LOES se considerarán para el proceso de vacaciones 22 días ordinarios y 8 días de fin de semana; y para el personal de Código de trabajo 11 días ordinarios y 4 días de fin de semana."
    //const numMes = meses[Key.toLowerCase()]
    const mostrar_fecha_tabla = (fecha_formatear: Date) => {
        var particion = formatoFecha(fecha_formatear.toISOString()).split("/")
    
        return particion[0] + "/" + particion[1]
    }

    async function HandleClickVerDetalleHistorial(anioDeseado: number) {
        if (typeof (props.verDetalleHistorico) === "function") await props.verDetalleHistorico(anioDeseado);
    }

    const componenteVerDetalle = useMemo(() => {
        return (<div className="float-right">
            <span className='verDetalleHistorialSolicVac'>Ver Detalle</span>
            <span>
                <i className="fa-solid fa-eye verDetalleHistorialSolicVac ml-2" onClick={() => HandleClickVerDetalleHistorial(key)}></i>
            </span>
        </div>)

    }, [])

    const datosUsuario = authenticationService.currentUserValue.token;

    return (
        <>
            <Card className="cardHistorialVacaciones">
                <CardTitle className="cardHeaderHistorialSolicitudesVacaciones" style={{ backgroundColor: props.color, minHeight: '40px' }}>
                    <div>
                        {key}
                    </div>
                </CardTitle>
                 
                <CardBody style={{ overflowY: 'auto'}}>
                    <div id="container-HistorialSolicitudesPermisos" className='container_informacion_historial'>
                    <Table className="tableHistorialSolicitudesVacaciones" responsive>
                        <thead>
                            <tr>
                            <th className='head-tabla'>Permiso / Licencia</th>
                            <th className='head-tabla'>#Días</th>
                            <th className='head-tabla'>#Horas</th>
                            <th className='head-tabla'>Estado</th>
                            <th className='head-tabla'></th>
                            </tr>
                        </thead>
                        <tbody>
                                {value  && (
                                    value.map((lista, index) => (
                                    <tr key={index} className="rowHistorialSolicitudVacaciones">
                                        <td>
                                            <div className='texto-tabla'>
                                                {lista.tipoSolicitud}
                                            </div>
                                        </td>
                                        <td >
                                                <div className='texto-tabla'>
                                                    {lista.diasSolicitados}
                                            </div>
                                        </td>
                                        <td className='body-cell'>
                                                <div className='texto-tabla'>
                                                    {lista.horasSolicitadas}
                                            </div>
                                        </td>
                                        
                                            <td className='body-cell'>
                                                {(lista.estado == "A" && lista.refSolicitud) ? (
                                                <div className='texto-tabla'>
                                                    Registrado por UATH
                                                </div>
                                                ) : (
                                                        <div className='texto-tabla'>
                                                            Pendiente de confirmación
                                                        </div>
                                            )}
                                            {lista.estado == "O" && (
                                                <div className='texto-tabla'>
                                                    Rechazado por Directivo
                                                </div>
                                            )}
                                            {lista.estado == "R" && (
                                                <div className='texto-tabla'>
                                                    Anulada Usuario
                                                </div>
                                            )}
                                            {lista.estado == "N" && (
                                                <div className='texto-tabla'>
                                                    Rechazada por UATH
                                                </div>
                                            )}
                                            {lista.estado == "H" && (
                                                <div className='texto-tabla'>
                                                    Rechazado Doctor ESPOL
                                                </div>
                                                )}
                                                {lista.estado == "V" && (
                                                    <div className='texto-tabla'>
                                                        Vencida
                                                    </div>
                                                )}
                                            </td>
                                            <td className='body-cell'>
                                                {lista.refSolicitud && (
                                                    <i
                                                        onClick={async () => await DownloadDocument(lista.refSolicitud, datosUsuario, "Solicitud.pdf")}
                                                        data-toggle="tooltip"
                                                        data-placement="top"
                                                        title="Descargar Solicitud"
                                                    >
                                                        <img
                                                            src={PdfSVG}
                                                            className="acciones"
                                                            alt="Descargar Solicitud"
                                                            data-toggle="tooltip"
                                                            data-placement="top"
                                                            title="Descargar Solicitud"
                                                            style={{ width: 24, height: 24 }}
                                                        />
                                                    </i>
                                                )}
                                            </td>
                                    </tr>  
                                )
                                )
                            )}
                        </tbody>
                        </Table>
                        
                    </div>


                    


                </CardBody>
                {
                    <CardFooter>

                    {componenteVerDetalle}

                    </CardFooter>
                }

            </Card>
        </>
    )
}
